import React from "react"
import {Link} from "gatsby"
import Img from "gatsby-image"
import Reactmarkdown from "react-markdown"

const NewsItem = ({ title, thumb, date, excerpt, slug, id  }) => {

  return (
    <div
      className="col-12 col-md-6 mb-3"
      key={id}
    >
      <div className="news-box news-box-shadow" >
        <figure>
          <Img
            fluid={thumb.childImageSharp.fluid}
            title={title}
            className="object-fit"
          />
        </figure>
        <div className="box-inner p-4 p-xxl-5">
          <div className="news-title">
            <p className="data">{date}</p>
            <h3>{title}</h3>
          </div>
          <div className="news-body">
            <Reactmarkdown
              source={excerpt}
              escapeHtml={false}
            />
          </div>
          <Link to={`/aktualnosci/${slug}`} className="link-more">
            Czytaj więcej
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NewsItem
